import * as React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  loadingContainer: {
    display: 'flex',
  },
});

export default function Loading() {
  const classes = useStyles();

  return (
    <Box className={classes.loadingContainer}>
      <CircularProgress />
    </Box>
  );
}
